import * as React from "react";
import Box from "@mui/joy/Box";
import Button from "@mui/joy/Button";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";
import Input from "@mui/joy/Input";
import Table from "@mui/joy/Table";
import Sheet from "@mui/joy/Sheet";
import Typography from "@mui/joy/Typography";
import Checkbox from '@mui/joy/Checkbox';
import CircularProgress from "@mui/joy/CircularProgress";
import DownloadIcon from '@mui/icons-material/Download';

import SearchIcon from "@mui/icons-material/Search";

import { IReportData } from "../../utils/types";
import { useGetMyActivityLogsQuery, useGetPullbackInvoiceMutation } from "../../services/invoices/InvoiceApiSlice";

import { displayOptional, downloadBase64File } from "../../utils/utils";
import { apiBaseUrl } from "../../utils/constants";
import { DialogTitle, IconButton, Modal, ModalDialog, Stack } from "@mui/joy";
import { start } from "repl";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useGetFileContantMutation } from "../../services/vendor/VendorApi";
import ClearIcon from '@mui/icons-material/Clear';

const ITEMS_PER_PAGE = 10;

export default function ActionLogTable() {
    const pernr = localStorage.getItem("employee_id");
    const navigate = useNavigate();

    const [getFileContant] = useGetFileContantMutation();
    const [getPullBackInvoice, { isLoading: ispullbackloading }] = useGetPullbackInvoiceMutation();

    const tableHeaders: Array<{
        id: keyof IReportData | 'billno' | 'action' | 'action_date' | 'send_to' | 'comments';
        label: string;
        minWidth: number;
        numeric?: boolean;
        disableSort?: boolean;
    }> = [
            { id: "bts_no", label: "BTS No.", minWidth: 130 },
            { id: "vendor_name", label: "Vendor Name", minWidth: 130 },
            { id: "vendor_code", label: "Vendor Code", minWidth: 130 },

            { id: "billno", label: "Invoice", minWidth: 150 },
            { id: "action", label: "Action", minWidth: 150 },
            { id: "action_date", label: "Action Date", minWidth: 150 },
            { id: "send_to", label: "Send To", minWidth: 150 },
            { id: "comments", label: "Comments", minWidth: 150 },

        ];

    const [isOpen, setisOpen] = React.useState(false);
    const [startDate, setStartDate] = React.useState("");
    const [endDate, setEndDate] = React.useState("");
    const [locationList, setLocationList] = React.useState([]);
    const [currentPage, setCurrentPage] = React.useState(1);
    const [selectedList, setSelectedList] = React.useState([]);
    const [isForward, setIsForward] = React.useState<any>(false);
    const [filterInputs, setFilterInputs] = React.useState({
        bts_no: "",
        invoice_status: [] as string[],
        vendor_code: "",
        vendor_name: "",
        // location: "",
        invoiceNo: '',
    });

    const clearFilter = () => {
        setFilterInputs({ bts_no: "", invoice_status: [] as string[], vendor_code: "", vendor_name: "", invoiceNo: '' });
    };

    const [debouncedFilters, setDebouncedFilters] = React.useState(filterInputs);


    // const { data: fetchLoction } = useGetFetchLocationQuery(0);

    // React.useEffect(() => {
    //     if (fetchLoction?.data) {
    //         const list = fetchLoction?.data.map((item) => {
    //             return { label: item.location_txt, value: item.Location_code };
    //         });
    //         setLocationList([...list]);
    //     }
    // }, [fetchLoction])



    React.useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedFilters(filterInputs);
        }, 500);
        return () => {
            clearTimeout(handler);
        };
    }, [filterInputs]);

    const isSearchActive = React.useMemo(
        () => !!(debouncedFilters.bts_no || debouncedFilters.invoice_status.length > 0 || debouncedFilters.vendor_name || debouncedFilters.vendor_code),
        [debouncedFilters]
    );

    const searchApiArgs = {
        bts_no: debouncedFilters.bts_no,
        vendor_name: debouncedFilters.vendor_name,
        vendor_code: debouncedFilters.vendor_code,
        // location: debouncedFilters.location,
        status: debouncedFilters.invoice_status.join(","),
        invoiceNo: debouncedFilters.invoiceNo,
        page: currentPage,
        per_page: ITEMS_PER_PAGE,
        pernr: pernr,
    };

    Object.keys(searchApiArgs).forEach((key) => {
        if (searchApiArgs[key] == null || searchApiArgs[key] === "") {
            delete searchApiArgs[key];
        }
    });

    const { data, isLoading, error: errorEmployeeInvoices, isFetching } = useGetMyActivityLogsQuery(searchApiArgs);

    const displayedData = data;
    const entries = displayedData?.data || [];
    const pagination = displayedData?.pagination;

    const handlePrevPage = () => {
        setCurrentPage((prev) => Math.max(prev - 1, 1));
    };

    const handleNextPage = () => {
        if (pagination) {
            setCurrentPage((prev) => Math.min(prev + 1, pagination?.pages));
        }
    };

    const handleFilterChange = (setter: (value: any) => void, value: any) => {
        setCurrentPage(1);
        setter(value);
    };
    const handleBtsNoChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        handleFilterChange((val) => setFilterInputs((prev) => ({ ...prev, bts_no: val })), event.target.value);
    };
    // const handleInvoiceStatusChange = (selectedStatusValues: string[]) => {
    //     handleFilterChange((val) => setFilterInputs((prevArgs) => ({ ...prevArgs, invoice_status: val })), selectedStatusValues);
    //     // setFilterInputs((prevArgs) => ({ ...prevArgs, invoice_status: [selectedStatusValues[0]] }))
    // };
    const handleVendorCodeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        handleFilterChange((val) => setFilterInputs((prev) => ({ ...prev, vendor_code: val })), event.target.value);
    };
    const handleInvoiceNoChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        handleFilterChange((val) => setFilterInputs((prev) => ({ ...prev, invoiceNo: val })), event.target.value);
    };
    const handleVendorNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        handleFilterChange((val) => setFilterInputs((prev) => ({ ...prev, vendor_name: val })), event.target.value);
    };
    // const handleLocationChange = (selectedValue: any) => {
    //     setFilterInputs({ ...filterInputs, location: selectedValue.value });
    //     setCurrentPage(1);
    // };


    const onHandleDownloadDocumentFile = async (docNumber: any, year: any) => {

        try {
            const response: any = await getFileContant("doc_num=" + docNumber + "&fiscal_year=" + year);

            if (response?.data?.success) {
                var fileData = response?.data?.message;
                downloadBase64File(fileData?.FileContent, fileData?.DocNo + "-" + fileData?.Fyear, fileData?.MimeType);
            } else {
                toast.error(response?.error?.data?.message || response?.data?.message || response?.message);
            }
        } catch (err) {
            let errorMessage = "An error occurred. " + (err?.data?.message || err?.message);
            toast.error(errorMessage);
        }
    }


    const handleView = (invoiceId) => {
        //const invoiceId = invoice.id;

        navigate(`/employee/view-invoice-entry/${btoa(btoa(invoiceId))}`, {
            state: { isReadOnly: true }, // Tell the component to be read-only
        });
    };

    const onHandleChangeRow = (btnNo: any, target: any) => {
        let temp = [...selectedList];
        if (target.checked) {
            temp.push(btnNo);
            setSelectedList([...temp]);
        } else {
            let temp1 = temp.filter((item) => item !== btnNo);
            setSelectedList([...temp1]);
        }
    }
    const onHandleCheckUnCheckAll = (target: any) => {
        let temp = [];
        const displayedData = data;
        const entrie = displayedData?.data || [];
        if (target.checked) {
            entrie.map((item: any) => temp.push(item?.invoice_id));
        }
        setSelectedList([...temp]);
    }

    const onHendleSendSelectedList = async () => {
        try {

            let payload = { "invoice_ids": [...selectedList] };
            const response: any = await getPullBackInvoice(payload);
            if (response?.data?.message) {
                toast.success(response?.data?.message);
                setSelectedList([]);
            } else {
                toast.error(response?.error?.data?.message);
            }

        } catch (err) {
            let errorMessage = "An error occurred. " + (err?.data?.message || err?.message);
            toast.error(errorMessage);
        }
    }


    const handleDownloadExcel = () => {
        if (startDate === '') {
            toast.error('Start date is required.');
            return;
        }
        if (endDate === '') {
            toast.error('End date is required.');
            return;
        }
        let d1 = new Date(startDate);
        let d2 = new Date(endDate);
        if (d1.getTime() > d2.getTime()) {
            toast.error('Start date not greate then end date.');
        }
        var date1 = startDate.split("-");
        var date2 = endDate.split("-");
        const formatted1 = `${date1[2]}-${date1[1]}-${date1[0]}`;
        const formatted2 = `${date2[2]}-${date2[1]}-${date2[0]}`;
        const url = apiBaseUrl + '/download-excel?start_date=' + formatted1 + '&end_date=' + formatted2 + "&pernr=" + localStorage.getItem("employee_id");

        const a = document.createElement("a");
        a.href = url;
        a.target = "_blank"
        a.click();
        URL.revokeObjectURL(url);
        setisOpen(false);
    }
    const renderFilters = () => (
        <>
            <FormControl size="sm" sx={{ width: "inherit" }}>
                <FormLabel>Search by BTS No.</FormLabel>
                <Input placeholder="Search BTS No." startDecorator={<SearchIcon />} value={filterInputs.bts_no} onChange={handleBtsNoChange} />
            </FormControl>
            {/* <Box sx={{ width: "inherit" }}>
                <MultiSelectCheckboxDropdown
                    label="Invoice Status"
                    options={invoiceStatusOptionsEmployee}
                    selectedValues={filterInputs?.invoice_status || []}
                    onChange={handleInvoiceStatusChange}
                    placeholder="Filter by status"
                    size="sm"
                />
            </Box> */}
            <FormControl size="sm" sx={{ width: "inherit" }}>
                <FormLabel>Search by Vendor Name</FormLabel>
                <Input placeholder="Vendor Name" startDecorator={<SearchIcon />} value={filterInputs.vendor_name} onChange={handleVendorNameChange} />
            </FormControl>
            <FormControl size="sm" sx={{ width: "inherit" }}>
                <FormLabel>Search by Vendor Code</FormLabel>
                <Input placeholder="Vendor Code" startDecorator={<SearchIcon />} value={filterInputs.vendor_code} onChange={handleVendorCodeChange} />
            </FormControl>
            <FormControl size="sm" sx={{ width: "inherit" }}>
                <FormLabel>Search by Invoice No.</FormLabel>
                <Input placeholder="Invoice No" startDecorator={<SearchIcon />} value={filterInputs.invoiceNo} onChange={handleInvoiceNoChange} />
            </FormControl>
            {/* <FormControl size="sm">
                <FormLabel>Search by Location</FormLabel>
                <Autocomplete
                    style={{ width: '100%' }}
                    placeholder="Choose location"
                    options={locationList}
                    sx={{ width: 200 }}
                    // value={filterInputs?.location}
                    onChange={(event, newInputValue) => {
                        handleLocationChange(newInputValue);
                        // handlechooseGemInvoiceMember(newInputValue, index, invoice);
                    }}
                />
            </FormControl> */}
            {(filterInputs?.bts_no !== "" || filterInputs?.invoice_status?.length !== 0 || filterInputs?.vendor_code !== "" || filterInputs?.vendor_name !== "" || filterInputs?.invoiceNo !== "") && (
                <FormControl size="sm" sx={{ width: "inherit" }}>
                    <FormLabel>&nbsp;</FormLabel>
                    <div>
                        <Button onClick={clearFilter} sx={{ maxWidth: "fit-content" }} size="sm" variant="soft" color="danger">
                            <ClearIcon />
                        </Button>
                        <IconButton aria-label="delete" size="lg" onClick={() => setisOpen(true)} sx={{ minHeight: 'unset' }}>
                            <DownloadIcon fontSize="inherit" style={{ transform: 'scale(1.5)' }} />
                        </IconButton>
                    </div>
                </FormControl>
            )}
        </>
    );

    if (errorEmployeeInvoices) {
        return (
            <Typography color="danger" sx={{ p: 4, textAlign: "center" }}>
                Error loading data.
            </Typography>
        );
    }

    if (isLoading) {
        return (
            <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
                <CircularProgress />
            </Box>
        );
    }

    return (
        <React.Fragment>
            <>
                {/* <Box sx={{ display: 'flex' }}> */}
                <Box
                    className="SearchAndFilters-tabletUp"
                    sx={{
                        borderRadius: "sm",
                        // pt: 2,
                        // pb: 1,
                        display: { xs: "flex", sm: "grid" },
                        flexDirection: { xs: "column", sm: "row" },
                        gridTemplateColumns: { sm: "repeat(7, 1fr)" },
                        gridTemplateRows: { sm: "repeat(2, auto)" },
                        gap: 2,
                        width: "100%",
                        flexWrap: "wrap",
                        "& > *": { minWidth: { xs: "120px", md: "160px" } },
                    }}
                >
                    {renderFilters()}
                </Box>
            </>

            <Sheet
                className="OrderTableContainer"
                variant="outlined"
                sx={{
                    width: "100%",
                    borderRadius: "sm",
                    flexShrink: 1,
                    overflow: "auto",
                    minHeight: 300,
                }}
            >
                <Table
                    aria-labelledby="tableTitle"
                    stickyHeader
                    hoverRow
                    sx={{
                        "--TableCell-headBackground": "var(--joy-palette-background-level1)",
                        "--Table-headerUnderlineThickness": "1px",
                        "--TableRow-hoverBackground": "var(--joy-palette-background-level1)",
                    }}
                >
                    <thead>
                        <tr>
                            <th className="heading-3" style={{
                                width: '50px',
                                minWidth: '50px',
                                padding: "12px 6px",
                                textAlign: "center",
                            }}>
                                <Checkbox
                                    checked={selectedList.length === entries?.length}
                                    indeterminate={selectedList.length > 0 && selectedList.length < entries?.length}
                                    onChange={(e) => onHandleCheckUnCheckAll(e.target)}
                                />

                            </th>
                            {tableHeaders.map((headCell) => (
                                <th
                                    className="heading-3"
                                    key={headCell.id}
                                    style={{
                                        width: headCell.minWidth,
                                        minWidth: headCell.minWidth,
                                        padding: "12px 6px",
                                        textAlign: "center",
                                    }}
                                >
                                    <Typography fontWeight="lg" level="body-sm">
                                        {headCell.label}
                                    </Typography>
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {isFetching ? (
                            <tr>
                                <td colSpan={tableHeaders?.length} style={{ textAlign: "center", padding: "16px" }}>
                                    <CircularProgress />
                                </td>
                            </tr>
                        ) : entries?.length === 0 ? (
                            <tr>
                                <td colSpan={tableHeaders?.length} style={{ textAlign: "center", padding: "16px" }}>
                                    <Typography>
                                        No bills found
                                        {isSearchActive ? " matching your filters." : "."}
                                    </Typography>
                                </td>
                            </tr>
                        ) : (
                            entries.map((invoice: any) => (
                                <tr key={invoice.id || invoice.bts_no}>
                                    <td style={{ textAlign: "center", wordBreak: "break-all" }}>
                                        <Checkbox
                                            checked={selectedList.includes(invoice?.invoice_id)}
                                            onChange={(e) => onHandleChangeRow(invoice?.invoice_id, e.target)}
                                        />
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                        <Typography level="body-xs">{displayOptional(invoice?.bts_no)}</Typography>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                        <Typography level="body-xs">{displayOptional(invoice?.vendor_name)}</Typography>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                        <Typography level="body-xs">{displayOptional(invoice?.vendor_code)}</Typography>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                        <Typography level="body-xs">{displayOptional(invoice?.invoice_id)}</Typography>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                        <Typography level="body-xs">{displayOptional(invoice?.action)}</Typography>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                        <Typography level="body-xs">{displayOptional(invoice?.date)}</Typography>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                        <Typography level="body-xs">{displayOptional(invoice?.sent_to)}</Typography>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                        <Typography level="body-xs">{displayOptional(invoice?.comments)}</Typography>
                                    </td>

                                </tr>
                            ))
                        )}
                    </tbody>
                </Table>
            </Sheet>

            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    pt: 0,
                }}
            >

                <Box sx={{ display: "flex", gap: 1 }}>
                    <Button size="sm" variant="outlined" onClick={handlePrevPage} disabled={!pagination || pagination?.page <= 1}>
                        Previous
                    </Button>
                    <Typography level="body-sm" sx={{ mx: 1, display: 'flex', alignItems: 'center' }}>
                        Page {pagination?.page} of {pagination?.pages}
                    </Typography>
                    <Button size="sm" variant="outlined" onClick={handleNextPage} disabled={!pagination || pagination?.page >= pagination?.pages}>
                        Next
                    </Button>
                    <Button size="sm" className="btn btn-primary" disabled={selectedList.length === 0} onClick={() => onHendleSendSelectedList()}>
                        {ispullbackloading ? "Sending..." : 'Pull Back'}
                    </Button>
                </Box>
            </Box>


            <Modal open={isOpen} onClose={() => setisOpen(false)}>
                <ModalDialog>
                    <DialogTitle>Download Report</DialogTitle>

                    <Stack spacing={2}>
                        <FormControl>
                            <FormLabel>Start Date</FormLabel>
                            <Input type="date" onChange={(e) => setStartDate(e.target.value)} />
                        </FormControl>
                        <FormControl>
                            <FormLabel>End Date</FormLabel>
                            <Input type="date" onChange={(e) => setEndDate(e.target.value)} />
                        </FormControl>
                        <Button onClick={() => handleDownloadExcel()}>Download</Button>
                    </Stack>
                </ModalDialog>
            </Modal>
        </React.Fragment>
    );
}



function getFiscalYearCode(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = date.getMonth() + 1; // 1–12

    var fiscalYearStart: any = '';
    if (month >= 4) {
        fiscalYearStart = year;
    }
    else {
        fiscalYearStart = year - 1;
    }
    return fiscalYearStart;
}